import styled from "styled-components";
import { paragraphSize } from "../utils";

export const Container = styled.div`
  box-sizing: border-box;
  background: #000C29;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const HeaderSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 29px 0;
`

export const VideoSection = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const SliderSection = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NewParagraph = styled.p`
  font-size: ${props => paragraphSize(props.size)}px;
  font-family: "${props => props.type || 'Nunito'}", sans-serif;
  font-weight: ${props => props.weight || 400};
  text-align: ${props => props.align || 'center'};
  font-style: normal;
  color: ${props => props.color || '#fff'};
  line-height: 27px;

  b {
    font-weight: 700;
  }
`
export const VideoContainer = styled.div`
  width: 75%;
  margin-top: 1.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0px 0px 229px 0px #1B229F75;


  .videoSide {
    width: 70%;
    height: 60vh;
  }

  .commentSide {
    width: 30%;
    height: 60vh;
  }

  @media (min-width: 1600px) {
    width: 75%;
  }

  @media (max-width: 1366px) {
    width: 90%;

    .videoSide {
      width: 100%;
      height: 50vh
    }
    
     .commentSide {
      display: none;
    }
  }
`;